import { useState } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import BreathingModal from "./BreathingModal";

export default function BreathingFAB() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="Open breathing exercise"
            onClick={() => setOpen(true)}
            className="fixed bottom-20 right-16 md:bottom-6 md:right-24 z-50 flex items-center justify-center rounded-full shadow-lg hover:shadow-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background transition-all duration-200 hover:scale-105 active:scale-95"
            style={{
              width: 52,
              height: 52,
              backgroundColor: "#2D5A3D",
            }}
          >
            <span className="relative flex items-center justify-center w-full h-full">
              {/* Outer static ring */}
              <span
                className="absolute rounded-full border-2"
                style={{
                  width: 28,
                  height: 28,
                  borderColor: "rgba(255,255,255,0.7)",
                }}
                aria-hidden="true"
              />
              {/* Inner pulsing circle */}
              <span
                className="rounded-full breathing-fab-pulse"
                style={{
                  width: 16,
                  height: 16,
                  backgroundColor: "#D6EAE0",
                }}
                aria-hidden="true"
              />
            </span>
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          sideOffset={8}
          className="rounded-full px-3 py-1.5 text-xs font-medium text-white border-none"
          style={{ backgroundColor: "#2D5A3D" }}
        >
          Breathing Exercise
        </TooltipContent>
      </Tooltip>

      <BreathingModal open={open} onClose={() => setOpen(false)} />

      <style>{`
        @keyframes breathing-fab-pulse {
          0%, 100% { transform: scale(0.7); opacity: 0.7; }
          50% { transform: scale(1); opacity: 1; }
        }
        .breathing-fab-pulse {
          animation: breathing-fab-pulse 4s ease-in-out infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .breathing-fab-pulse { animation: none; }
        }
      `}</style>
    </>
  );
}
